import { render, staticRenderFns } from "./VehicleReestrModel.vue?vue&type=template&id=6e517d90&"
import script from "./VehicleReestrModel.vue?vue&type=script&lang=js&"
export * from "./VehicleReestrModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports